
















































































































































import { Component, Prop, Vue } from 'vue-property-decorator';
import { AppliedLessonType } from '@/enums/AppliedLessonType';
import { validate } from '@/helpers/validation/validate';
import { hideModal } from '@/helpers/modal';
import { Getter } from 'vuex-class';
import type { Project } from '@/models/project';
import { showErrorNotification } from '@/helpers/showErrorNotification';
import { ValidationResult } from '@/helpers/validation/Validator';
import FormError from '@/components/utils/FormError.vue';
import { showSuccessNotification } from '@/helpers/showSuccessNotification';
import type { CompanySetting } from '@/models/companySetting';
import { getCombinedProjectUsers } from '@/helpers/getCombinedProjectUsers';
import { CombinedUser } from '@/helpers/getCombinedProjectUsers';
import FormTopicPicker from '@/components/form/FormTopicPicker.vue';
import FormSubprocessPicker from '@/components/form/FormSubprocessPicker.vue';
import FormItem from '@/components/form/FormItem.vue';
import FormProjectUserPicker from '@/components/form/FormProjectUserPicker.vue';
import FormDynamicFieldPicker from '@/components/form/FormDynamicFieldPicker.vue';
import PrineButton from '@/components/prine/PrineButton.vue';
import type { User } from '@/models/user';
import type { XWorksheet } from '@/models/xworksheet';
import { xAppliedLessonWebservice } from '@/webservices/xappliedlesson';
import type { XLesson } from '@/models/xlesson';
import type { XAppliedLesson } from '@/models/xappliedlesson';

@Component({
    name: 'WorksheetCreateXAppliedLessonModal',
    components: {
        FormDynamicFieldPicker,
        FormProjectUserPicker,
        FormItem,
        FormSubprocessPicker,
        FormTopicPicker,
        FormError,
        PrineButton,
    },
})
export default class WorksheetCreateXAppliedLessonModal extends Vue {
    get users(): CombinedUser[] {
        return getCombinedProjectUsers(this.selectedProject);
    }
    protected disabled: boolean = false;
    @Prop({
        required: true,
    })
    private type: AppliedLessonType;

    @Prop({
        required: true,
    })
    private worksheet: XWorksheet;

    @Prop({
        required: false,
    })
    private saved: (options: {}) => void;

    private hideModal = hideModal;

    private addToKnowledgeBase = false;

    @Getter('account/companySetting') private companySetting: CompanySetting;
    @Getter('utils/currentLocale') private currentLocale: string;

    @Getter('project/selectedProject') private selectedProject: Project;

    private validation: ValidationResult = { success: false, errors: [] };

    private data: {
        insight: string;
        todo: string;
        responsible_user: User | null;
        contacttill: Date | null;
        solution: string;
        topic: {};
        x_sub_process: undefined;
        dynamic_field: undefined;
        cost: undefined;
        probability: undefined;
    } = {
        insight: '',
        todo: '',
        responsible_user: null,
        contacttill: null,
        solution: '',
        topic: {},
        x_sub_process: undefined,
        dynamic_field: undefined,
        cost: undefined,
        probability: undefined,
    };

    hasMsIntegration() {
        return this.selectedProject.ms_integration === 'done' || this.selectedProject.ms_integration === 'pending';
    }

    private save() {
        const validations: Record<string, string[]> = {
            insight: ['required', 'string'],
        };

        validations.x_sub_process = ['required'];
        this.validation = validate(validations, this.data);

        if (!this.validation.success) {
            return false;
        }

        this.disabled = true;

        xAppliedLessonWebservice.getByWorksheetId(this.worksheet.id).then((response) => {
            const appliedLessons = response.data.map((appliedLesson) => {
                const responsible_user_id = appliedLesson.responsible_user_id
                    ? appliedLesson.responsible_user_id
                    : appliedLesson.external_responsible_user_id;

                const user = this.users.find((_) => _.user_id === responsible_user_id);

                appliedLesson.responsible_user = user ? user : null;

                return appliedLesson;
            });

            // neutralize time zone
            if (this.data.contacttill) {
                this.data.contacttill = new Date(
                    this.data.contacttill.setMinutes(
                        this.data.contacttill.getMinutes() - this.data.contacttill.getTimezoneOffset()
                    )
                );
            }
            // We have to do quite a bit of workaround here since there is no dedicated "add new single applied lesson" endpoint.
            const newXAppliedLesson = {
                id: 0,
                done: false,
                needscheck: false,
                checked: false,
                x_lesson: {
                    id: 0,
                    insight: this.data.insight,
                    project_only: !this.addToKnowledgeBase,
                    x_sub_process: this.data.x_sub_process,
                } as Partial<XLesson>,
                insight: this.data.insight,
                todo: this.data.todo,
                responsible_user: this.data.responsible_user,
                contacttill: this.data.contacttill ? new Date(this.data.contacttill) : null,
                solution: this.data.solution,
                dynamic_field: this.data.dynamic_field,
                cost: this.data.cost,
                probability: this.data.probability,
            } as Partial<XAppliedLesson>;

            xAppliedLessonWebservice
                .store(this.worksheet.id, appliedLessons, [newXAppliedLesson as XAppliedLesson])
                .then((response2) => {
                    showSuccessNotification('toastMessages.store.lesson');
                    hideModal();
                    if (this.saved) {
                        this.saved({ highlight: response2.data.id });
                    }
                })
                .catch(() => {
                    showErrorNotification('toastMessages.error.worksheet');
                    this.disabled = false;
                    this.disabled = false;
                });
        });
    }
}
